import {
  Wrench, GraduationCap, HeartPulse, Sprout, Droplets, Users, Accessibility,
  Sparkles, Baby, Trees, Scissors, ShieldAlert, Bath, SunMedium, PawPrint,
  Recycle, Landmark, Trophy,
} from "lucide-react";

export const CAUSES = [
  { id: "vocational", name: "Skill & Vocational Training", name_ta: "தொழில் பயிற்சி", Icon: Wrench },
  { id: "education", name: "Primary & Rural Education", name_ta: "ஆரம்பக் கல்வி", Icon: GraduationCap },
  { id: "healthcare", name: "Community Health & Clinics", name_ta: "சமூக சுகாதாரம்", Icon: HeartPulse },
  { id: "agriculture", name: "Sustainable Agriculture", name_ta: "இயற்கை வேளாண்மை", Icon: Sprout },
  { id: "water", name: "Water & Watershed", name_ta: "நீர் மேலாண்மை", Icon: Droplets },
  { id: "eldercare", name: "Elder Care & Dignity", name_ta: "முதியோர் பராமரிப்பு", Icon: Users },
  { id: "disability", name: "Disability & Inclusion", name_ta: "மாற்றுத்திறனாளி நலன்", Icon: Accessibility },
  { id: "women", name: "Women & Self-Help Groups", name_ta: "மகளிர் குழுக்கள்", Icon: Sparkles },
  { id: "child", name: "Child Welfare & Nutrition", name_ta: "குழந்தைகள் நலன்", Icon: Baby },
  { id: "environment", name: "Trees & Greenery", name_ta: "வனவள பாதுகாப்பு", Icon: Trees },
  { id: "artisan", name: "Artisan & Handloom Revival", name_ta: "கைத்தறி நெசவு", Icon: Scissors },
  { id: "disaster", name: "Disaster Relief", name_ta: "பேரிடர் நிவாரணம்", Icon: ShieldAlert },
  { id: "sanitation", name: "Hygiene & Sanitation", name_ta: "துப்புரவு & சுகாதாரம்", Icon: Bath },
  { id: "renewable", name: "Solar & Off-grid Energy", name_ta: "சூரிய சக்தி", Icon: SunMedium },
  { id: "animal", name: "Animal Welfare & Rescue", name_ta: "விலங்குகள் பராமரிப்பு", Icon: PawPrint },
  { id: "waste", name: "Waste & Recycling", name_ta: "கழிவு மறுசுழற்சி", Icon: Recycle },
  { id: "arts", name: "Arts & Heritage", name_ta: "கலை & பாரம்பரியம்", Icon: Landmark },
  { id: "sports", name: "Youth Sports", name_ta: "இளைஞர் விளையாட்டு", Icon: Trophy },
];

export const DISTRICTS = [
  { id: "erode", name: "Erode" }, { id: "coimbatore", name: "Coimbatore" },
  { id: "tiruppur", name: "Tiruppur" }, { id: "salem", name: "Salem" },
  { id: "namakkal", name: "Namakkal" },
];

export const CREDENTIAL_TYPES = [
  { id: "DARPAN", label: "DARPAN ID" }, { id: "CSR1", label: "CSR-1 (MCA)" },
  { id: "12A", label: "12A" }, { id: "80G", label: "80G" },
  { id: "10_23C", label: "10(23C)" }, { id: "FCRA", label: "FCRA" },
];

export const BUDGET_BANDS = [
  { id: "under_5l", label: "Under ₹5 Lakh" }, { id: "5l_25l", label: "₹5–25 Lakh" },
  { id: "25l_1cr", label: "₹25 L – 1 Cr" }, { id: "above_1cr", label: "Above ₹1 Cr" },
];
